<template>
  <div class="dashboard-sidebar-wrapper" :class="{ 'sidebar-disabled': disabled }">
  <div class="dashboard-sidebar">
    <div class="sidebar-top">
      <div class="sidebar-brand">
        <div class="sidebar-logo">
          <img
            :src="logoShieldIcon"
            alt="SentryKit"
            class="sidebar-logo-img"
          />
        </div>
      </div>
      <div class="sidebar-logo-divider"></div>
    </div>
    <nav class="sidebar-nav">
      <a
        v-for="item in mainNavItems"
        :key="item.id"
        :class="['nav-item', { active: currentPath === item.path }]"
        @click="onNavClick(item.path)"
        @mouseenter="onNavHover(item)"
      >
        <img
          v-if="iconMap[item.id]"
          :src="currentPath === item.path ? iconMap[item.id].white : iconMap[item.id].grey"
          class="nav-icon-svg"
          :alt="item.label"
        />
        <span class="nav-label">{{ item.label }}</span>
        <span v-if="item.badgeCount != null" :class="['nav-badge', item.badge === 'warning' ? 'warning' : '']">{{ item.badgeCount }}</span>
      </a>
      <div class="sidebar-nav-divider"></div>
      <a
        :class="['nav-item', { active: isSettingsActive }]"
        @click="onNavClick('/settings')"
        title="Settings"
      >
        <img
          :src="isSettingsActive ? iconMap.settings.white : iconMap.settings.grey"
          class="nav-icon-svg"
          alt="Settings"
        />
        <span class="nav-label">Settings</span>
      </a>
    </nav>
  </div>
  </div>
</template>

<script>
import './styles/DashboardSidebar.css'
import { tenantIdFromIdentityBody } from '../../utils/orderVolumeBilling.js'

var brandAssets = require('../../utils/brandAssets.js')
var logoShieldIcon = brandAssets.logoShieldIcon

const iconMap = {
  home: {
    white: require('../../assets/icons/sidebar/dashboard-white.svg'),
    grey: require('../../assets/icons/sidebar/dashboard-grey.svg')
  },
  products: {
    white: require('../../assets/icons/sidebar/products-white.svg'),
    grey: require('../../assets/icons/sidebar/products-grey.svg')
  },
  issues: {
    white: require('../../assets/icons/sidebar/alerts-white.svg'),
    grey: require('../../assets/icons/sidebar/alerts-grey.svg')
  },
  stock: {
    white: require('../../assets/icons/sidebar/stock-white.svg'),
    grey: require('../../assets/icons/sidebar/stock-grey.svg')
  },
  feeClaims: {
    white: require('../../assets/icons/sidebar/fee-claims-white.svg'),
    grey: require('../../assets/icons/sidebar/fee-claims-grey.svg')
  },
  settings: {
    white: require('../../assets/icons/sidebar/settings-white.svg'),
    grey: require('../../assets/icons/sidebar/settings-grey.svg')
  }
}

export default {
  name: 'DashboardSidebar',
  props: {
    items: {
      type: Array,
      required: true
    },
    currentPath: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      logoShieldIcon,
      iconMap
    }
  },
  computed: {
    mainNavItems: function () {
      return this.items.filter(function (item) { return item.id !== 'settings' })
    },
    isSettingsActive: function () {
      return this.currentPath === '/settings' || this.currentPath.indexOf('/settings/') === 0
    }
  },
  mounted: function () {
    var self = this
    var schedule = this.$root.scheduleAfterFirstPaint
      ? this.$root.scheduleAfterFirstPaint.bind(this.$root)
      : function (fn) { setTimeout(fn, 50) }
    schedule(function () {
      self.loadSidebarBillingContext()
    })
  },
  methods: {
    timezoneOffsetMinutes: function () {
      return 0 - new Date().getTimezoneOffset()
    },
    /** Keep root billing fields in sync for trial strip / lockout (no order meter). */
    loadSidebarBillingContext: function () {
      var self = this
      if (this.$root.loadSubscriptionSummary) {
        this.$root.loadSubscriptionSummary()
      }
      var identityPromise = this.$root.loadIdentitySettings
        ? this.$root.loadIdentitySettings()
        : this.$http.get('/api/identity/settings').then(function (res) { return res.body || {} }, function () { return {} })
      identityPromise.then(function (body) {
        body = body || {}
        var tenantId = tenantIdFromIdentityBody(body)
        if (self.$root) {
          self.$root.tenantId = tenantId || self.$root.tenantId
          self.$root.hasDailyPricing = !!body.dailyPricing
          self.$root.billingUserTypeRaw =
            body.subscriptionBillingUserType ||
            body.user_type ||
            body.billingUserType ||
            body.billing_user_type ||
            self.$root.billingUserTypeRaw
        }
      })
      var paymentPromise = this.$root.loadPaymentStatus
        ? this.$root.loadPaymentStatus()
        : this.$http.get('/api/billing/payment-status', {
          params: { timezoneOffsetMinutes: this.timezoneOffsetMinutes() }
        }).then(function (res) { return res.body || {} }, function () { return {} })
      paymentPromise.then(function (body) {
        body = body || {}
        if (!self.$root) return
        self.$root.billingPackageDetails = body.packageDetails || null
        var bsRaw = body.billingSummary || body.billing_summary || {}
        self.$root.billingSummary = Object.assign({}, bsRaw)
        var fromPayment = body.user_type || body.userType || body.subscriptionBillingUserType
        if (fromPayment) self.$root.billingUserTypeRaw = fromPayment
      })
    },
    onNavClick: function (path) {
      if (this.disabled) return
      this.$emit('navigate', path)
    },
    onNavHover: function (item) {
      if (!item || item.path !== '/issues') return
      if (this.currentPath === '/issues') return
      if (this.$root && typeof this.$root.prefetchIssuesAlertCounts === 'function') {
        this.$root.prefetchIssuesAlertCounts()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashboardSidebar.vue?c66e92a6